import api from './index';
import { Forecaster, ForecasterEditForm, ForecasterForm } from '../types/Forecaster.interface';
import { AxiosResponse } from 'axios';

const BASE = '/forecasters';

export const getForecasters = async () => {
    return api.get<Forecaster[]>(BASE).then((res) => res.data);
};

export const createForecaster = async ({ name, userId }: ForecasterForm) => {
    return api
        .post<Forecaster, AxiosResponse<Forecaster>, ForecasterForm>(`${BASE}`, { name, userId })
        .then((res) => res.data);
};

export const deleteForecaster = async (id: number) => {
    return api.delete<Forecaster, AxiosResponse<Forecaster>, number>(`${BASE}/${id}`).then((res) => res.data);
};

export const updateForecaster = async ({ id, name, userId }: ForecasterEditForm) => {
    return api
        .patch<Forecaster, AxiosResponse<Forecaster>, ForecasterForm>(`${BASE}/${id}`, { name, userId })
        .then((res) => res.data);
};
